import { render, staticRenderFns } from "./Renewal5TyjManagement.vue?vue&type=template&id=b5be8f68&scoped=true&"
import script from "./Renewal5TyjManagement.vue?vue&type=script&lang=js&"
export * from "./Renewal5TyjManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5be8f68",
  null
  
)

export default component.exports